import React from "react";
import TutorInfoForm from "../components/Tutor/TutorInfoForm";

const TutorDashboard = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-indigo-100 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8">
        <h2 className="text-3xl font-bold text-indigo-700 mb-6 text-center">
          👨‍🏫 Tutor Dashboard
        </h2>
        <TutorInfoForm />
      </div>
    </div>
  );
};

export default TutorDashboard;
